import { render, staticRenderFns } from "./policyDetails.vue?vue&type=template&id=1b213279&scoped=true&"
import script from "./policyDetails.vue?vue&type=script&lang=js&"
export * from "./policyDetails.vue?vue&type=script&lang=js&"
import style0 from "./policyDetails.vue?vue&type=style&index=0&id=1b213279&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b213279",
  null
  
)

export default component.exports